import { AppContext } from "next/app";

export const DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
export const PRODDOMAIN = "https://admin.ipbexpo.com";
export const PRODFORNTDOMAIN = "http://ipbexpo.smartinfo.cn";
// export const PRODDOMAIN = "http://cbce.smartinfo.cn";

